import { ApiType } from "@gymflow/common";
import { useQuery } from "@tanstack/react-query";

import { emailTemplateQueryKeys } from "./emailTemplateQueryKeys";

export const emailTemplateListQueryFn = async ({
  api,
  opts,
}: {
  api: ApiType;
  opts: Parameters<ApiType["emailTemplateApi"]["find"]>[0];
}) => {
  return (await api.emailTemplateApi.find({ ...opts })).data;
};

export function useEmailTemplateList({
  api,
  opts,
}: {
  api: ApiType;
  opts: Parameters<ApiType["emailTemplateApi"]["find"]>[0];
}) {
  return useQuery({
    queryKey: emailTemplateQueryKeys.list(opts),
    queryFn: async () => await emailTemplateListQueryFn({ api, opts }),
  });
}
